import { React, useState, useEffect, useContext } from "react";
import { AppContext } from '../../../../AppStore';
import axios from "axios";
import Swal from "sweetalert2";
import Button from "@mui/material/Button";
import DownloadIcon from '@mui/icons-material/Download';
import Moment from 'moment';
import GridNoRow from '../../../../common/GridNoRow';
import { DataGrid, GridActionsCellItem, useGridApiRef } from '@mui/x-data-grid';
import { useParams } from 'react-router-dom';
import { useNavigate, useLocation } from "react-router-dom";

const MOB_OrderDetail = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();
    const fromSearch = location.state?.fromSearch || {};
    const appStore = useContext(AppContext);
    const [MenuID, setMenuID] = useState(0);
    const [MenuName, setMenuName] = useState('');
    const [MenuUpdateExistYN, setMenuUpdateExistYN] = useState('N');
    const [MenuDeleteExistYN, setMenuDeleteExistYN] = useState('N');
    const [MenuUpdateYN, setMenuUpdateYN] = useState('N');
    const [MenuDeleteYN, setMenuDeleteYN] = useState('N');
    const [originRows, setOriginRows] = useState([]);
    const [data, setData] = useState(null);
    const [itemRows, setItemRows] = useState([]);
    const [itemColumns, setItemColumns] = useState([]);
    const [userRows, setUserRows] = useState([]);
    const [userColumns, setUserColumns] = useState([]);
    const [fileRows, setFileRows] = useState([]);
    const [fileColumns, setFileColumns] = useState([]);

    useEffect(() => {
        // 권한 설정은 주석 처리된 상태
        if(params.order_id === null || typeof params.order_id === 'undefined'){
            navigate("/m/order", { state: { fromSearch } });
        }

        setTimeout(() => { // 초기 화면인 경우 늦게 표시 됨.
            const accessList = JSON.parse(localStorage.getItem("nav"));
            if (Array.isArray(accessList) && accessList.filter(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).length > 0) {
                setMenuID(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_id);
                setMenuName(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_name);
                setMenuUpdateExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_exist_yn);
                setMenuDeleteExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_exist_yn);
                setMenuUpdateYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_yn);
                setMenuDeleteYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_yn);
            } else {
                Swal.fire({
                    title: '<p style="color:red">접근 권한 오류</p>',
                    text: '화면에 접근 권한이 없습니다.',
                    confirmButtonText: '확인',
                    confirmButtonColor: '#7066e0',
                    timer: 5000,
                    timerProgressBar: true
                }).then((value) => {
                    return navigate(-1);
                });
            }
        }, 800);
    }, []);
    
    useEffect(() => {
        setItemColumns([
            { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
            { field: 'order_item_id', headerName: 'order_item_id', headerAlign: 'center', align:'center' },
            { field: 'order_item_name', headerName: '품목', width: 250, headerAlign: 'center', align:'left' },
            { field: 'order_item_count', headerName: '수주수량', type: 'number', width: 150, headerAlign: 'center', align:'right' },
            { field: 'order_item_price_currency_name', headerName: '통화단위', type: 'text', width: 150, headerAlign: 'center', align:'center' },
            { field: 'order_item_price', headerName: '단가', type: 'number',width: 120, headerAlign: 'center', type: 'number'},
            { field: 'order_item_sv_price', headerName: '공급가액', type: 'number', width: 165, headerAlign: 'center', align:'right' },
            { field: 'order_item_vat_price', headerName: '부가세액', type: 'number',width: 165, headerAlign: 'center', align:'right' },
            { field: 'order_item_total_price', headerName: '합계금액', type: 'number',width: 165, headerAlign: 'center', align:'right' }
        ]);

        setUserColumns([
            { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
            { field: 'order_user_id', headerName: 'order_user_id', width: 0, headerAlign: 'center' },
            { field: 'order_user_name', headerName: '담당자명', width: 150, headerAlign: 'center', align:'center' },
            { field: 'order_user_dept_name', headerName: '담당자부서', width: 150, headerAlign: 'center', align:'center' },
            { field: 'order_user_position_name', headerName: '담당자직위', width: 150, headerAlign: 'center', align:'center' },
            { field: 'order_user_type_name', headerName: '담당자유형', type: 'text', width: 150, headerAlign: 'center', align:'center' },
            { field: 'order_user_bigo', headerName: '비고', width: 350, headerAlign: 'center', align:'left' }
        ]);

        setFileColumns([
            {
                field: 'download',
                headerName: '다운로드',
                width: 100,
                type:'actions',
                disableClickEventBubbling: true,
                getActions: (params) => [
                    <GridActionsCellItem icon={<DownloadIcon color={ "primary" } />} onClick={() => {fileDownloadClick(params)}} label="Download" />
                ],
                headerAlign: 'center', 
                align:'center'
            },
            { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
            { field: 'file_name_sever', headerName: 'file_name_sever', width: 0, headerAlign: 'center' },
            { field: 'file_size', headerName: 'file_size', width: 0, headerAlign: 'center' },
            { field: 'file_type', headerName: 'file_type', width: 0, headerAlign: 'center' },
            { field: 'file_extension', headerName: 'file_extension', width: 0, headerAlign: 'center' },
            { field: 'file_name', headerName: '파일명', width: 270, headerAlign: 'center' },
            { field: 'file_type_name', headerName: '유형', width: 120, headerAlign: 'center', align:'center' },
            { field: 'file_size_dp', headerName: '크기', width: 120, headerAlign: 'center', align:'right' },
            { field: 'reg_user_name', headerName: '등록자', width: 120, headerAlign: 'center', align:'center' },
            { field: 'reg_datetime', headerName: '등록일시', width: 180, headerAlign: 'center', align:'center' },
        ]);
        
        if(String(MenuID) !== String(0) && typeof fromSearch.originRows === 'undefined'){
            handleSearch();
        }else{
            setOriginRows(fromSearch.originRows);
        }
    }, [MenuID]);

    useEffect(() => {
        if(typeof originRows !== 'undefined'){
            if(originRows.length > 0){
                setData(
                    {
                        order_id: originRows[0].order_id,
                        order_name: originRows[0].order_name,
                        order_number: originRows[0].order_number,
                        order_date: originRows[0].order_date,
                        order_partner_name: originRows[0].order_partner_name,
                        order_partner_manager: originRows[0].order_partner_manager,
                        order_partner_manager_phone: originRows[0].order_partner_manager_phone,
                        order_partner_manager_mail: originRows[0].order_partner_manager_mail,
                        order_partner_delivery_post: originRows[0].order_partner_delivery_post,
                        order_partner_delivery_address: originRows[0].order_partner_delivery_address,
                        order_partner_delivery_address_add: originRows[0].order_partner_delivery_address_add,
                        order_bigo: originRows[0].order_bigo
                    }
                )

                var itemData = originRows.filter((item, index) => {
                    return (
                        originRows.findIndex((item2, index2) => {
                        return typeof item.order_item_seq !== 'undefined' && item.order_item_seq === item2.order_item_seq;
                        }) === index
                    );
                });
                
                itemData = itemData.sort(function(a, b) { 
                    return a.order_item_seq < b.order_item_seq ? -1 : a.order_item_seq > b.order_item_seq ? 1 : 0;
                });

                setItemRows(itemData.map((item, index) => ({
                    id: item.order_item_seq,
                    order_item_id: item.order_item_id,
                    order_item_name: item.order_item_name + ' ' +appStore.ITEM_FULL_SPEC_MAKE( item.order_item_spec, item.order_item_width, item.order_item_depth, item.order_item_height),
                    order_item_count: item.order_item_count,
                    order_item_price_currency: item.order_item_price_currency,
                    order_item_price_currency_name: item.order_item_price_currency_name,
                    order_item_price: item.order_item_price,
                    order_item_sv_price: item.order_item_sv_price,
                    order_item_vat_price: item.order_item_vat_price,
                    order_item_total_price: item.order_item_total_price
                })));

                var userData = originRows.filter((item, index) => {
                    return (
                    originRows.findIndex((item2, index2) => {
                        return typeof item.order_user_seq !== 'undefined' && item.order_user_seq === item2.order_user_seq;
                    }) === index
                    );
                });
            
                userData = userData.sort(function(a, b) { 
                    return a.order_user_seq < b.order_user_seq ? -1 : a.order_user_seq > b.order_user_seq ? 1 : 0;
                });
            
                setUserRows(userData.map((item, index) => ({
                    id: item.order_user_seq,
                    order_user_id: item.order_user_id,
                    order_user_name: item.order_user_name,
                    order_user_dept_name: item.order_user_dept_name,
                    order_user_position_name: item.order_user_position_name,
                    order_user_type: item.order_user_type,
                    order_user_type_name: item.order_user_type_name,
                    order_user_bigo: item.order_user_bigo
                })));
            
            
                var fileData = originRows.filter((item, index) => {
                    return (
                    originRows.findIndex((item2, index2) => {
                        return typeof item.order_file_id !== 'undefined' && item.order_file_id === item2.order_file_id;
                    }) === index
                    );
                });
            
                fileData = fileData.sort(function(a, b) { 
                    return a.order_file_id < b.order_file_id ? -1 : a.order_file_id > b.order_file_id ? 1 : 0;
                });
            
                setFileRows(fileData.map((item, index) => ({
                    id: item.order_file_id,
                    file_name_sever: item.order_file_name_sever,
                    file_size: item.order_file_size,
                    file_type: item.order_file_type,
                    file_extension: item.order_file_extension,
                    file_name: item.order_file_name,
                    file_type_name: item.order_file_type_name,
                    file_size_dp: item.order_file_size_dp,
                    reg_user_name: item.order_file_user_name,
                    reg_datetime: Moment(item.order_file_user_datetime).format('YYYY-MM-DD HH:mm:ss')
                })));
            }
        }
    }, [originRows]);

    const handleSearch = () => {
        if (appStore.loading) return;
        appStore.setLoading(true);
        
        axios.get('/api/p/Order/List',
            {
                params: {
                    order_id: params.order_id
                }
            },
            { withCredentials: true }
        )
        .then((response) => {
            setOriginRows(response.data);
        })
        .catch((error) => {
            appStore.capture();
        })
        .finally(() => {
            appStore.setLoading(false); 
        });
    };

    const fileDownloadClick = (object) => {
        const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent)
                    || (navigator.userAgent.includes('Mac') && 'ontouchend' in document);

        if (isIOS) {
            // iOS는 XHR+blob 대신, 폼 POST로 새 탭 열어 서버가 직접 다운로드 처리
            const form = document.createElement('form');
            form.method = 'POST';
            form.action = '/api/SaveCommon/FileDownload';
            form.target = '_blank'; // 새 탭 (팝업 차단 회피용: 클릭 안에서 즉시 submit)

            const add = (n, v) => {
                const input = document.createElement('input');
                input.type = 'hidden';
                input.name = n;
                input.value = v ?? '';
                form.appendChild(input);
            };
            add('fileName', object.row.file_name);
            add('fileNameSever', object.row.file_name_sever);
            document.body.appendChild(form);
            form.submit();
            form.remove();
            return;
        }

        // 나머지(PC/안드): 기존 axios + blob
        axios.post(
            '/api/SaveCommon/FileDownload',
            new URLSearchParams({
                fileName: object.row.file_name,
                fileNameSever: object.row.file_name_sever
            }),
            { withCredentials: true, responseType: 'blob' }
        ).then((res) => {
            if (res.status !== 200) return appStore.capture();
            const type = res.headers?.['content-type'] || 'application/octet-stream';
            const blob = new Blob([res.data], { type });
            const url  = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = object.row.file_name || 'download.bin';
            document.body.appendChild(a);
            a.click();
            a.remove();
            URL.revokeObjectURL(url);
        }).catch((e) => {
            appStore.capture();
            console.log('다운로드 실패', e);
        });
    };

    const handleList = () => {
        navigate("/m/order", { state: { fromSearch } });
    };

    return (
        <div style={{ width: '100%', display: String(MenuID) === String(0) ? 'hidden' : 'block' }}>
            <div className="M_menubox">
                <div className="menu-action">
                    <div className="menu-title">{ MenuName }</div>
                    <div style={{ float: 'right' }}>
                        <Button
                            onClick={handleList}
                            className="M_btn-p"
                            sx={{
                                m: 1,
                                fontSize: 15,
                                color: "white", 
                                borderColor: "black", 
                                backgroundColor: "black",
                                ":hover": { boxShadow: "2px 2px 2px black" , backgroundColor: "black", borderColor: "black"}
                            }}
                            variant="outlined">
                            목록
                        </Button>
                    </div>
                </div>
            </div>

            <div className="M_contents">
                <div style={{ overflow: 'hidden' }}>
                    {/* 수주 기본 정보 */}
                    {data ? (
                        <>
                        <div style={{
                            backgroundColor: '#fdfdfd',
                            marginTop: '10px',
                            borderRadius: '12px',
                            padding: '10px',
                            marginBottom: '24px',
                            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
                            border: '1px solid #eee'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
                            <span style={{ fontSize: '24px', marginRight: '8px' }}>ℹ️</span>
                            <h2 style={{ fontSize: '22px', fontWeight: '700', color: '#222', margin: 0 }}>수주 정보</h2>
                            </div>

                            <div style={{ padding: '8px 0', borderBottom: '1px solid #eee' }}>
                            <div style={{ fontSize: '18px', fontWeight: '600', color: '#444' }}>수주명</div>
                            <div style={{ fontSize: '16px', color: '#333', marginTop: '4px' }}>{data.order_name || '-'}</div>
                            </div>

                            <div style={{ padding: '8px 0', borderBottom: '1px solid #eee' }}>
                            <div style={{ fontSize: '18px', fontWeight: '600', color: '#444' }}>수주일자</div>
                            <div style={{ fontSize: '16px', color: '#333', marginTop: '4px' }}>{data.order_date || '-'}</div>
                            </div>

                            <div style={{ padding: '8px 0', borderBottom: '1px solid #eee' }}>
                            <div style={{ fontSize: '18px', fontWeight: '600', color: '#444' }}>수주번호</div>
                            <div style={{ fontSize: '16px', color: '#333', marginTop: '4px' }}>{data.order_number || '-'}</div>
                            </div>

                            <div style={{ padding: '8px 0', borderBottom: '1px solid #eee' }}>
                            <div style={{ fontSize: '18px', fontWeight: '600', color: '#444' }}>수주처</div>
                            <div style={{ fontSize: '16px', color: '#333', marginTop: '4px' }}>{data.order_partner_name || '-'}</div>
                            </div>

                            <div style={{ padding: '8px 0', borderBottom: '1px solid #eee' }}>
                            <div style={{ fontSize: '18px', fontWeight: '600', color: '#444' }}>수주처 배송지</div>
                            <div style={{ fontSize: '16px', color: '#333', marginTop: '4px' }}>
                                {
                                [data.order_partner_delivery_post, data.order_partner_delivery_address, data.order_partner_delivery_address_add]
                                    .filter((v) => v && v.trim() !== '')
                                    .join(' / ') || '-'
                                }
                            </div>
                            </div>

                            <div style={{ padding: '8px 0', borderBottom: '1px solid #eee' }}>
                            <div style={{ fontSize: '18px', fontWeight: '600', color: '#444' }}>수주처 담당자</div>
                            <div style={{ fontSize: '16px', color: '#333', marginTop: '4px' }}>
                                {
                                [data.order_partner_manager, data.order_partner_manager_phone, data.order_partner_manager_mail]
                                    .filter((v) => v && v.trim() !== '')
                                    .join(' / ') || '-'
                                }
                            </div>
                            </div>

                            <div style={{ padding: '8px 0' }}>
                            <div style={{ fontSize: '18px', fontWeight: '600', color: '#444' }}>비고</div>
                            <div 
                                style={{ 
                                fontSize: '16px', 
                                color: '#333', 
                                marginTop: '4px',
                                whiteSpace: 'pre-wrap', // 줄바꿈 유지
                                lineHeight: '1.5'       // 가독성 좋게 줄 간격 추가
                                }}
                            >
                                {(data.order_bigo && data.order_bigo.trim() !== '') 
                                ? data.order_bigo 
                                : '-'}
                            </div>
                            </div>
                        </div>

                        <div style={{
                            backgroundColor: '#fdfdfd',
                            marginTop: '10px',
                            borderRadius: '12px',
                            padding: '10px',
                            marginBottom: '24px',
                            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
                            border: '1px solid #eee'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
                            <span style={{ fontSize: '24px', marginRight: '8px' }}>ℹ️</span>
                            <h2 style={{ fontSize: '22px', fontWeight: '700', color: '#222', margin: 0 }}>수주 품목</h2>
                            </div>

                            <div style={{ padding: '0px', height: '300px' }}>
                                <DataGrid
                                    rows={itemRows}
                                    columns={itemColumns}
                                    slots={{
                                        noRowsOverlay: GridNoRow,
                                    }}
                                    initialState={{ 
                                        density: 'compact',
                                        pagination: {
                                            paginationModel: { pageSize: 5, page: 0 },
                                        },
                                    }}
                                    columnVisibilityModel={{id: false, order_item_id: false}}              
                                    sx={{
                                        '& .MuiDataGrid-columnHeaderTitle': {
                                        fontSize: '15px',
                                        fontWeight: 'bold'
                                        }
                                    }}
                                />
                            </div>
                        </div>

                        <div style={{
                            backgroundColor: '#fdfdfd',
                            marginTop: '10px',
                            borderRadius: '12px',
                            padding: '10px',
                            marginBottom: '24px',
                            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
                            border: '1px solid #eee'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
                            <span style={{ fontSize: '24px', marginRight: '8px' }}>ℹ️</span>
                            <h2 style={{ fontSize: '22px', fontWeight: '700', color: '#222', margin: 0 }}>수주 담당자</h2>
                            </div>

                            <div style={{ padding: '0px', height: '300px' }}>
                                <DataGrid
                                    rows={userRows}
                                    columns={userColumns}
                                    slots={{
                                        noRowsOverlay: GridNoRow,
                                    }}
                                    initialState={{ 
                                        density: 'compact',
                                        pagination: {
                                            paginationModel: { pageSize: 5, page: 0 },
                                        },
                                    }}
                                    columnVisibilityModel={{id: false, order_user_id: false}}              
                                    sx={{
                                        '& .MuiDataGrid-columnHeaderTitle': {
                                        fontSize: '15px',
                                        fontWeight: 'bold'
                                        }
                                    }}
                                />
                            </div>
                        </div>

                        <div style={{
                            backgroundColor: '#fdfdfd',
                            marginTop: '10px',
                            borderRadius: '12px',
                            padding: '10px',
                            marginBottom: '24px',
                            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
                            border: '1px solid #eee'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
                            <span style={{ fontSize: '24px', marginRight: '8px' }}>ℹ️</span>
                            <h2 style={{ fontSize: '22px', fontWeight: '700', color: '#222', margin: 0 }}>수주 파일</h2>
                            </div>

                            <div style={{ padding: '0px', height: '300px' }}>
                                <DataGrid
                                    rows={fileRows}
                                    columns={fileColumns}
                                    slots={{
                                        noRowsOverlay: GridNoRow,
                                    }}
                                    initialState={{ 
                                        density: 'compact',
                                        pagination: {
                                            paginationModel: { pageSize: 5, page: 0 },
                                        },
                                    }}
                                    columnVisibilityModel={{id: false, file_name_sever: false, file_size: false, file_type : false, file_extension: false, download: false}}
                                    sx={{
                                        '& .MuiDataGrid-columnHeaderTitle': {
                                        fontSize: '15px',
                                        fontWeight: 'bold'
                                        }
                                    }}
                                />
                            </div>
                        </div>
                        </>
                    ) : (
                        <p style={{ textAlign: "center", color: "#999" }}>수주 데이터를 불러오는 중입니다...</p>
                    )}
                    </div>

            </div>
        </div>
    );
};

export default MOB_OrderDetail;